import React from "react";

const ArchiveIcon = ({
  className = "",
  width = "20",
  height = "20",
  color = "white",
  restProps,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M17.9931 5H9.7931C9.54412 5.00166 9.29928 4.9362 9.08435 4.81051C8.86941 4.68481 8.69231 4.50353 8.57167 4.28571L6.72167 1.04286C6.54142 0.726297 6.28061 0.463072 5.96573 0.279911C5.65084 0.0967508 5.2931 0.000178251 4.92882 0H1.92167C1.41266 0.00188178 0.925027 0.204922 0.565096 0.564852C0.205166 0.924783 0.00212592 1.41241 0.000244141 1.92143V17.95C0.00213425 18.4943 0.219703 19.0158 0.605287 19.4C0.990871 19.7843 1.51303 20 2.05739 20H17.9502C18.4934 19.9981 19.0137 19.7815 19.3977 19.3975C19.7818 19.0134 19.9984 18.4931 20.0002 17.95V7.00714C20.0002 6.47482 19.7888 5.96429 19.4124 5.58788C19.036 5.21147 18.5254 5 17.9931 5ZM18.5717 17.95C18.5717 18.1148 18.5062 18.2729 18.3897 18.3894C18.2731 18.506 18.1151 18.5714 17.9502 18.5714H2.05739C1.97518 18.5724 1.8936 18.557 1.81738 18.5262C1.74116 18.4954 1.67181 18.4498 1.61335 18.392C1.55488 18.3342 1.50847 18.2653 1.47679 18.1895C1.44512 18.1136 1.42881 18.0322 1.42882 17.95V1.92143C1.42882 1.85671 1.44156 1.79262 1.46633 1.73282C1.4911 1.67302 1.5274 1.61869 1.57317 1.57293C1.61894 1.52716 1.67327 1.49086 1.73306 1.46609C1.79286 1.44132 1.85695 1.42857 1.92167 1.42857H4.92882C5.04173 1.4285 5.15267 1.45817 5.25048 1.51459C5.34828 1.57102 5.4295 1.65221 5.48596 1.75L7.35024 5C7.59385 5.43363 7.94857 5.79454 8.37791 6.04561C8.80726 6.29669 9.29573 6.42888 9.7931 6.42857H17.9931C18.1465 6.42857 18.2937 6.48953 18.4022 6.59803C18.5107 6.70653 18.5717 6.8537 18.5717 7.00714V17.95Z"
        fill={color}
      />
      <path
        d="M6.42787 15.7143H3.57073C3.38129 15.7143 3.19961 15.7895 3.06565 15.9235C2.9317 16.0574 2.85645 16.2391 2.85645 16.4285C2.85645 16.618 2.9317 16.7997 3.06565 16.9336C3.19961 17.0676 3.38129 17.1428 3.57073 17.1428H6.42787C6.61731 17.1428 6.799 17.0676 6.93295 16.9336C7.0669 16.7997 7.14216 16.618 7.14216 16.4285C7.14216 16.2391 7.0669 16.0574 6.93295 15.9235C6.799 15.7895 6.61731 15.7143 6.42787 15.7143Z"
        fill={color}
      />
    </svg>
  );
};

export default ArchiveIcon;
